import type { MemberType } from './MemberProfile.types'
import type { PermissionCheck } from '@percent/admin-dashboard/common/hooks/usePermissions'
import { AccountType, TENANTLESS_ACCOUNT, accountDomainPermissions, domainsCoveringAccount } from '@percent/domain/iam'

/**
 * What each member profile route requires to open, so the routes and the account search (whose
 * results must all be openable) agree. The general profile shows a typeless account, which is in
 * no tenant: pbp-api lets `accounts` and `organisation_accounts` see those, never `partner_accounts`.
 */
export const MEMBER_PROFILE_VIEW_PERMISSIONS: Record<MemberType, PermissionCheck> = {
  goodstack: 'accounts:can_view',
  partner: 'partner_accounts:can_view',
  organisation: 'organisation_accounts:can_view',
  general: { any: accountDomainPermissions(domainsCoveringAccount(TENANTLESS_ACCOUNT), 'can_view') }
}

/** The profile an account of each type opens on. */
export const MEMBER_TYPE_FOR_ACCOUNT_TYPE: Record<AccountType, MemberType> = {
  [AccountType.internal]: 'goodstack',
  [AccountType.partner]: 'partner',
  [AccountType.organisation]: 'organisation'
}
